"use strict";

exports.__esModule = true;
exports.DeviceCycleCollector = DeviceCycleCollector;
var _react = _interopRequireDefault(require("react"));
var _Timeline = require("../../Timeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Collects cycles for a particular device, supplying them to consumers via a render prop.
 */
function DeviceCycleCollector(_ref) {
  var deviceUuid = _ref.deviceUuid,
    interval = _ref.interval,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Timeline.LiveTimelineQueryController, {
    timelineName: "time-series-classification",
    interval: interval,
    query: {
      device: deviceUuid
    }
  }, children);
}